import React from 'react';
import { Grid } from '@material-ui/core';

import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined';
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';

import { KPICard } from '../../shared_components';

const trendTypeOf = (sub = '') => {
  if (sub.includes('↑')) return 'up';
  if (sub.includes('↓')) return 'down';
  return 'flat';
};

const DashboardKpiRow = ({ cards, loading }) => (
  <Grid container spacing={2} style={{ marginBottom: 5 }}>
    {(cards || []).map((card) => (
      <Grid item xs={12} sm={6} md={3} key={card?.key}>
        <KPICard
          title={card?.label}
          value={card?.value}
          subtitle={card?.sub}
          color={card?.kpiColor}
          icon={card?.icon}
          trend={card?.trend}
          trendType={trendTypeOf(card?.sub)}
          loading={loading}
        />
      </Grid>
    ))}
  </Grid>
);

export const KPI_ICONS = {
  plans_created: DescriptionOutlinedIcon,
  projects_closed: CheckCircleOutlineIcon,
  avg_project_duration_days: AccessTimeOutlinedIcon,
  on_time_launch_rate_pct: FlightTakeoffIcon,
};

export default DashboardKpiRow;
